import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MarkdownHooks } from "react-markdown";
import { MermaidBlock } from "react-markdown-mermaid";
import remarkGfm from "remark-gfm";
import { useAppSelector } from "../../../../../app/hooks";
import { selectLogics } from "../../../../logics/logicsSlice";
import { WindowTypeAndPropsDefinition } from "../../../windowManagerSlice";
import css from "./ReadmeWindow.module.css";

export interface ReadmeWindowProps {
	source: string;
}

export type ReadmeWindowTypeAndProps = WindowTypeAndPropsDefinition<
	"readme",
	ReadmeWindowProps
>;

export function ReadmeWindow(props: ReadmeWindowProps & { id: string }) {
	const { i18n } = useTranslation();
	const logics = useAppSelector(selectLogics);
	const [source, setSource] = useState("");

	useEffect(() => {
		const source = Object.entries(logics.readme).find(
			([id, _]) => id === props.source,
		)?.[1];

		if (!source) {
			setSource("No info available.");
			return;
		}

		if (source?.[i18n.language] === undefined) {
			setSource("Info not avaiable in this language");
			return;
		}

		if (source?.[i18n.language]) {
			const regexLocalImages = /(!\[.+\])\((\.\/.+)\)/g;
			const mermaid = source[i18n.language]
				.replace(/::: mermaid/g, "\`\`\`mermaid")
				.replace(/:::/g, "\`\`\`")
				.replace(regexLocalImages, `$1(imageapi/${source.image}\$2)`);

			setSource(mermaid);
		}
	}, [logics.readme]);

	return (
		<div className={css.content}>
			<MarkdownHooks
				remarkPlugins={[remarkGfm]}
				components={{
					code({ node, className, children, ...props }) {
						const match = /language-(\w+)/.exec(className || "");
						if (match && match[1] === "mermaid") {
							return <MermaidBlock code={children as string} />;
						}
						return (
							<code className={className} {...props}>
								{children}
							</code>
						);
					},
				}}
			>
				{source}
			</MarkdownHooks>
		</div>
	);
}
